// @ts-nocheck
import "./ReviewsListCollapse.scss";

import { Component, h, render } from "preact";
import { useCallback, useRef, useState } from "preact/hooks";

import { PlusIcon } from "../Icon/icons/fill/PlusIcon";
import ReviewForm from "../ReviewForm/ReviewForm";
import ReviewsList from "../ReviewsList/ReviewsList";
import Stars from "../ProductRating/ProductRating";
import { Theme } from "../Theme";
import cn from "classnames";
import { getCustomText } from "@/utils/getCustomText";
import { isDisabledCollapse } from "@/utils/isDisabledCollapse";

const collapseDisabled = isDisabledCollapse();

function ReviewsListCollapse({ productUid }) {
  const [collapsed, setCollapsed] = useState(collapseDisabled);
  const contentRef = useRef(null);
  const collapseRef = useRef(null);

  const toggleCollapse = useCallback(() => {
    if (collapseDisabled) return;

    if (collapsed) {
      // hide
      collapseRef.current.style.height = contentRef.current.clientHeight + "px";
      collapseRef.current.style.height = "0px";
      setCollapsed(false);
    } else {
      // show
      collapseRef.current.style.height = contentRef.current.clientHeight + "px";
      setCollapsed(true);
      window.setTimeout(() => (collapseRef.current.style.height = "auto"), 500);
    }
  });

  return (
    <Theme widget="reviewsListCollapseWidget">
      <div
        className={cn(
          "CCReviewsListCollapse",
          collapsed && "CCReviewsListCollapse_collapsed",
          collapseDisabled && "CCReviewsListCollapse_disable-collapse"
        )}
      >
        <div
          className="CCReviewsListCollapse__controls"
          onClick={toggleCollapse}
        >
          <div className="CCReviewsListCollapse__controls-left">
            <div className="CCReviewsListCollapse__title t-text">
              {getCustomText("reviewsCollapsedListTitle")}
            </div>
            <div className="CCReviewsListCollapse__stars">
              <Stars productUid={productUid} />
            </div>
          </div>
          <div class="CCReviewsListCollapse__action t-text">
            {getCustomText("reviewsCollapsedListAction")}
          </div>
          <div className="CCReviewsListCollapse__plus">
            <PlusIcon width={30} height={30} />
          </div>
        </div>
        <div ref={collapseRef} className="CCReviewsListCollapse__content">
          <div ref={contentRef}>
            {collapsed && (
              <div>
                <ReviewsList productUid={productUid} hideTitle />
                <ReviewForm productUid={productUid} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Theme>
  );
}

export default ReviewsListCollapse;
